const STORAGE_KEY = "writé:lang";

let current = "en";
try {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw === "tr" || raw === "en") current = raw;
} catch (e) {}

const listeners = new Set();

export const getLanguage = () => current;

export const setLanguage = (lang) => {
  if (lang !== "en" && lang !== "tr") return;
  current = lang;
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch (e) {}
  listeners.forEach((fn) => fn(current));
};

export const subscribeLanguage = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

const LETTER_REGEX = /^[a-zA-ZçğıöşüÇĞİÖŞÜ]$/;

export const isLetter = (ch) => LETTER_REGEX.test(ch);

const TR_LOWER_MAP = { "İ": "i", "I": "ı" };

export const normalizeLetter = (ch) => {
  if (TR_LOWER_MAP[ch]) return TR_LOWER_MAP[ch];
  return ch.toLowerCase();
};
